module.exports = vendor_library;


//////////////////
// WEBPACK FOOTER
// external "vendor_library"
// module id = 46
// module chunks = 38